<template>
    <div class="o-items-sorting-otg">
        <div v-dragscroll class="items-sorting-otg-letters-panel">
            <button
                v-for="letter in preparedItems"
                :key="letter.id"
                type="button"
                :class="['items-sorting-otg-letter-button', letter.activeCssClass ]"
                :disabled="letter.isDisabled"
                @click="onClick(letter.value)"
            >
                {{ letter.value }}
            </button>
        </div>
    </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll'
import { computed } from "@vue/composition-api";

import { ALPHABET } from "./constants";

export default {
    name: 'OItemsSortingOtg',
    props: {
        value: {
            type: String,
            default: ''
        },
        items: {
            type: Array,

        }
    },
    directives: {
        dragscroll
    },
    setup(props, { emit }) {
        const preparedItems = computed(() => {
            return ALPHABET.map((letter, id) => {
                const isActive = letter === props.value;
                const isDisabled = !props.items.includes(letter);

                return {
                    id,
                    value: letter,
                    activeCssClass: isActive ? 'items-sorting-otg-letter-button-active' : null,
                    isDisabled
                }
            })
        });

        function onClick(data) {
            emit('input', data);
        }

        return {
            ALPHABET,
            preparedItems,
            onClick
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />
